var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2783_48971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8004 17.1H1.82938C1.31633 17.1 0.900391 16.684 0.900391 16.1709V4.32114H11.6753V8.48797M3.68262 6.84271V3.50473C3.68262 2.06616 4.84914 0.899963 6.28812 0.899963C7.7271 0.899963 8.89358 2.06616 8.89358 3.50473L8.89329 6.98235M2.73644 6.98235H4.62824M7.9474 6.98235H8.89329M9.83919 6.98235H8.89329M15.1569 10.1407V10.6977C15.1569 11.6666 14.3712 12.4521 13.402 12.4521C12.4328 12.4521 11.6471 11.6666 11.6471 10.6977V10.1407M11.6753 8.48797H9.77379V16.4693C9.77379 16.8149 10.0539 17.0951 10.3995 17.0951H16.4054C16.751 17.0951 17.0311 16.8149 17.0311 16.4693V8.48797H11.6753Z",
    stroke: "#007FFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2783_48971"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetailIcon);
export default __webpack_public_path__ + "static/media/retailIcon.dda9383547dcb5733dc682275cddd6b9.svg";
export { ForwardRef as ReactComponent };